/**
 * Centralized API client with axios interceptors.
 * All service modules should import from here instead of defining
 * their own BACKEND_URL / getAuthHeaders.
 */
import axios from 'axios';

export const BACKEND_URL =
    process.env.REACT_APP_BACKEND_URL || window.location.origin;

export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Axios instance with auth header auto-attached when token exists.
 */
const apiClient = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
});

// Request interceptor — inject Bearer token when present
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor — unwrap data, handle 401
apiClient.interceptors.response.use(
    (response) => response.data, // auto-unwrap `.data`
    (error) => {
        if (error.response?.status === 401) {
            // Token expired / invalid — optionally clear & redirect
            // (AuthContext handles the redirect via its own state)
        }
        return Promise.reject(error);
    }
);

export default apiClient;

/**
 * Helper to get auth headers manually (for code not yet migrated to apiClient).
 * Prefer `apiClient` for new code.
 */
export const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};
